module.exports = __webpack_public_path__ + "static/img/logo-dark.a5a6af2c.png";